import React from 'react';

import MytaverseAppBar, {
  AppBarPositionEnum,
} from '@components/MytaverseAppBar';
import VirtualAssistant from '../VirtualAssistant';

const VirtualAssistantAppBar = () => {
  return (
    <MytaverseAppBar
      position={AppBarPositionEnum.BottomRight}
      isCollapsible={false}
      isGroup={false}
    >
      <VirtualAssistant />
    </MytaverseAppBar>
  );
};

export default VirtualAssistantAppBar;
